import {AxiosResponse} from 'axios'
import {secs35} from 'definitions/constant'
import {
  DownloadAnalyticsLogsPayload,
  DownloadAnalyticsLogsResponse,
  UnknownObject,
  NotificationParamsType,
  NotificationsResponse,
} from 'interfaces'
import {unwrapAPIError} from 'utils'
import {getPBFFServiceBaseUrl, requestHandler} from '../HTTP'
import {EndPoints, HttpMethods} from '../HTTP/HTTP.types'

const pbffBaseUrl = getPBFFServiceBaseUrl()

const downloadAnalyticsLogs = async (
  payload: DownloadAnalyticsLogsPayload,
): Promise<AxiosResponse<DownloadAnalyticsLogsResponse>> => {
  try {
    return await requestHandler<DownloadAnalyticsLogsResponse>({
      method: HttpMethods.POST,
      // Override axios baseUrl
      url: `${pbffBaseUrl}${EndPoints.AnalyticsDownload}`,
      data: payload as UnknownObject,
      options: {
        timeout: secs35,
      },
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const getNotifications = async (
  params: NotificationParamsType,
): Promise<AxiosResponse<NotificationsResponse>> => {
  try {
    return await requestHandler<NotificationsResponse>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${pbffBaseUrl}${EndPoints.GetNotification}`,
      options: {params},
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const PBFFService = {
  downloadAnalyticsLogs,
  getNotifications,
}
